export default () => {
  if (!customElements.get('newsletter-signup')) {
    customElements.define(
      'newsletter-signup',
      class NewsletterSignUp extends HTMLElement {
        constructor() {
          super();
          this.elements = {
            input: this.querySelector('input[name="email"]'),
            form: this.querySelector('.Footer__newsletter-signupForm'),
            headingForm: this.querySelector('.Footer__newsletter-heading'),
            errorDesktop: this.querySelector('.Footer__newsletter-signupForm-error-message.desktop'),
            errorMobile: this.querySelector('.Footer__newsletter-signupForm-error-message.mobile'),
            successHeadingForm: this.querySelector('.Footer__newsletter-success-heading'),
            successForm: this.querySelector('.Footer__newsletter-success-message'),
          };
          this.elements.form.addEventListener('submit', this.submitForm.bind(this));
        }

        submitForm() {
          const email = this.elements.input.value;

          if (!this.validateEmail(email)) {
            if (window.innerWidth > 760) {
              return this.elements.errorDesktop.classList.add('revealed');
            }
            return this.elements.errorMobile.classList.add('revealed');
          }

          this.elements.headingForm.classList.add('hidden');
          this.elements.successHeadingForm.classList.add('revealed');
          this.elements.successForm.classList.add('revealed');
          this.elements.form.classList.add('hidden');
          return;
        }

        /* eslint-disable no-useless-escape */
        validateEmail(email) {
          const reg =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return reg.test(email);
        }
      },
    );
  }
};
